module.exports = __webpack_public_path__ + "static/media/dashboard1.c8e3f26f.png";